import React from 'react';
import { compose, withHandlers, withProps, withState } from 'recompose';

const ThrottledButton = props => (
  <button {...props} />
);

const DEFAULT_TIMEOUT = 1000;

export default compose(
  withState('isInternallyDisabled', 'setIsInternallyDisabled', false),
  withHandlers({
    onClick: props => (...args) => {
      props.setIsInternallyDisabled(true);
      props.onClick(...args);

      const debounceTime = props.timeout || DEFAULT_TIMEOUT;
      setTimeout(() => {
        props.setIsInternallyDisabled(false);
      }, debounceTime);
    },
  }),
  withProps(props => ({
    disabled: props.disabled || props.isInternallyDisabled,
  })),
)(ThrottledButton);



// WEBPACK FOOTER //
// ./src/app/components/ThrottledButton.jsx